export default __webpack_public_path__ + "static/media/arbitrum_logo.17ba9b2d.svg";